import { useState } from 'react';

/**
 * Manages the status of the billing form and helpers
 * to pre-fill it from different sources (customer, agency, last payment).
 */
const useBillingForm = ({ lastBillingInfo }) => {
  const [billingInformation, setBillingInformation] = useState({
    doc_number: lastBillingInfo.billing_information_doc_number || '',
    address_street: lastBillingInfo.billing_information_address_street || '',
    first_name: lastBillingInfo.billing_information_first_name || ''
  });

  const fillFromClient = campaign => {
    setBillingInformation(prev => ({
      ...prev,
      doc_number: campaign.client.billing_information_tax_id || '',
      address_street: campaign.client.billing_information_address || '',
      first_name: campaign.client.billing_information_name || ''
    }));
  };

  const fillFromCompany = user => {
    setBillingInformation(prev => ({
      ...prev,
      doc_number: user.company.billing_information_tax_id || '',
      address_street: user.company.address || '',
      address_state: user.company.state || '',
      first_name: user.company.billing_information_name || ''
    }));
  };

  const fillFromLastBilling = () => {
    setBillingInformation(prev => ({
      ...prev,
      doc_number: lastBillingInfo.billing_information_doc_number || '',
      address_street: lastBillingInfo.billing_information_address_street || '',
      first_name: lastBillingInfo.billing_information_first_name || ''
    }));
  };

  const handleBillingSource = (value, campaign, user) => {
    if (value === 'client') fillFromClient(campaign);
    else if (value === 'company') fillFromCompany(user);
    else if (value === 'lastBilling') fillFromLastBilling();
  };

  return {
    billingInformation,
    setBillingInformation,
    handleBillingSource
  };
};

export default useBillingForm;
